/* eslint-disable default-case */
import React, { useMemo } from "react";

import {
    ButtonRowDelete,
    ButtonRowDownload,
    ButtonRowEdit,
    ButtonRowUpload,
} from "components/base/BaseButton";

import Filters from "./NumbersFilters";
import { MODALS, openModal } from "./Store/ModalsReducer";
import { buildColumnsByMode, filterColumnsByDisplay } from "./Config/Columns";
import { useAllocatedNumbersController } from "./hooks";
import { SecondStagedCell, StyledActionCell } from "./Styles";
import FiltersPanel from "./Sections/FiltersPanel";
import TopBarActions from "./Sections/TopBarActions";
import TableSection from "./Sections/TableSection";
import ModalsHost from "./Sections/ModalsHost";
import AllocatedNumbersAccountContainer from "./Containers/AllocatedNumbersAccountContainer";
import AllocatedNumbersSupplierContainer from "./Containers/AllocatedNumbersSupplierContainer";

import { Table } from "rsuite";

const { Column, HeaderCell, Cell } = Table;

const AllocatedNumbersRefactored = (props) => {
    const controller = useAllocatedNumbersController(props);
    const {
        mode,
        filterRef,
        tableRef,
        selectedListRef,
        modalDispatch,
        footerActionsDisabled,
        footerActionsLoading,
        selectedGanNumbers,
        selected,
        filterState,
        currentDisplay,
        searchLoading,
        sort,
        setSort,
        numberPageState,
        setNumberPageState,
        setCurrentPerPage,
        perPageLSKey,
        disabledActions,
        isDownloadInProgress,
        selectedItems,
        isMobile,
        loading,
        showToDate,
        onChangeFilters,
        onChangeGroup,
        getInitialValues,
        updateItems,
        proxyFilters,
        updateSelectedList,
        getDataForChangeRate,
        getDataForChangeSupplierRate,
        handleDownloadNumbersCsv,
        handleDownloadOnlyNumbers,
        keepSelectedItems,
        getSelectedNumbersCount,
        handleOpenSetActiveModal,
        handleOpenDeletePrefixesModal,
        handleOpenChangeRateModal,
        handleOpenChangeSupplierRateModal,
        handleGroupAction,
        ganNumberSuccess,
        modalHostProps,
        tableData,
        paging,
        permissionFlags,
        currentActions,
        responsiveTarget,
        isSupplierTrunks,
        getRowKey,
        columnSelectorLSKey,
    } = controller;

    const columnsByMode = useMemo(() => {
        return buildColumnsByMode({ service: props.service, showToDate, SecondStagedCell });
    }, [props.service, showToDate]);

    const tableColumns = mode === "transit"
        ? columnsByMode.transit
        : mode === "gan"
            ? columnsByMode.gan
            : columnsByMode.account;

    const filteredTableColumns = filterColumnsByDisplay(tableColumns, currentDisplay);

    const groupActionCell = (
        <Column width={138}>
            <HeaderCell>Options</HeaderCell>
            <Cell>
                {(rowData) => (
                    <StyledActionCell>
                        <ButtonRowEdit
                            mr={8}
                            onClick={() => handleGroupAction(MODALS.modifyGroup, rowData)}
                        />
                        <ButtonRowDownload
                            mr={8}
                            loading={rowData.downloadLoading}
                            onClick={() => props.groupDownloadNumbers(rowData.id)}
                        />
                        <ButtonRowUpload
                            mr={8}
                            onClick={() => handleGroupAction(MODALS.uploadGan, rowData)}
                        />
                        <ButtonRowDelete
                            mr={0}
                            onClick={() => handleGroupAction(MODALS.removeGroup, rowData)}
                        />
                    </StyledActionCell>
                )}
            </Cell>
        </Column>
    );

    const filterNode = (
        <Filters
            ref={filterRef}
            onChange={onChangeFilters}
            proxy={proxyFilters}
            disabled={searchLoading || loading}
            filters={filterState}
            isMobile={isMobile}
            currentDisplay={currentDisplay}
            currentRangeNumber={props.currentRangeNumber}
            onChangeGroup={onChangeGroup}
            isGanTrunks={props.isGanTrunks}
            isTransitTrunks={props.isTransitTrunks}
            downloadLoading={isDownloadInProgress}
            downloadDisabled={currentDisplay !== "trunk_number" || !props.trunk_id || isDownloadInProgress}
            onDownloadNumbersCsv={handleDownloadNumbersCsv}
            onDownloadOnlyNumbersCsv={handleDownloadOnlyNumbers}
        />
    );

    const topBarActionsNode = (
        <TopBarActions
            isMobile={isMobile}
            isTransitTrunks={props.isTransitTrunks}
            isGanTrunks={props.isGanTrunks}
            customRangesTrunk={props.customRangesTrunk}
            account={props.account}
            isDownloadInProgress={isDownloadInProgress}
            currentDisplay={currentDisplay}
            trunk_id={props.trunk_id}
            handleDownloadNumbersCsv={handleDownloadNumbersCsv}
            handleDownloadOnlyNumbers={handleDownloadOnlyNumbers}
            showAllocateTrunkButton={permissionFlags.showAllocateTrunkButton}
            showAllocatedNumbersModal={props.showAllocatedNumbersModal}
            closeAllocatedNumbersModal={props.closeAllocatedNumbersModal}
            currentTrunk={modalHostProps.currentTrunk}
            service={props.service}
            sp_key={props.sp_key}
            sp_auth={props.sp_auth}
            spOtpType={props.spOtpType}
            updateItems={updateItems}
            acc_key={props.acc_key}
            readonly={props.readonly}
            getTrunks={props.getTrunks}
            getTrunkNumberCsvById={props.getTrunkNumberCsvById}
            showAddPrefixButton={permissionFlags.showAddPrefixButton}
            currentSupplier={props.currentSupplier}
            suppliersPrefixDropdownList={props.suppliersPrefixDropdownList}
            getSupplierPrefixesDropdown={props.getSupplierPrefixesDropdown}
        />
    );

    const tableSectionProps = {
        tableRef,
        dataList: tableData,
        dataLoading: controller.dataLoading,
        filteredTableColumns,
        dataCount: paging.dataCount,
        dataPerPage: paging.dataPerPage,
        dataPage: paging.dataPage,
        getNumberList: controller.getNumberList,
        getRowKey,
        trunk_id: props.trunk_id,
        currentDisplay,
        setNumberPageState,
        perPageLSKey,
        onChangePerPage: setCurrentPerPage,
        setSort,
        isMobile,
        groupActionCell,
        isselected: filterRef && filterRef.current && filterRef.current.formValue ? !filterRef.current.formValue.actual : true,
        keepSelectedItems,
        updateSelectedList,
        columnSelectorLSKey,
        additionalColumnUpdate: showToDate,
    };

    const containerProps = {
        TableSection,
        tableSectionProps,
        actions: currentActions,
        selected,
        hasSelected: selected.all || (selected.list && selected.list.length),
        footerActionsDisabled,
        footerActionsLoading,
        disabledActions,
        ModalsHost,
        modalHostProps,
        isGanTrunks: props.isGanTrunks,
        isMobile,
        currentDisplay,
        selectedItems,
        dataCount: paging.dataCount,
        service: props.service,
        ganNumbersExtraParams: controller.ganNumbersExtraParams,
        hasGanBlocked: controller.hasGanBlocked,
        ganNumberSuccess,
        permissions: props.permissions,
        showReasonHandler: props.showReasonHandler,
        onOpenSetLimit: () => {
            modalDispatch(openModal(MODALS.setLimit));
        },
        isTransitTrunks: props.isTransitTrunks,
    };

    const Container = mode === "account" ? AllocatedNumbersAccountContainer : AllocatedNumbersSupplierContainer;

    return (
        <div>
            <FiltersPanel
                isMobile={isMobile}
                loading={loading}
                isGanTrunks={props.isGanTrunks}
                isTransitTrunks={props.isTransitTrunks}
                onChangeGroup={onChangeGroup}
                filterNode={filterNode}
                rightNode={topBarActionsNode}
            />

            <Container {...containerProps} />
        </div>
    );
};

export default AllocatedNumbersRefactored;
